import { fileuploadErrors } from '@user/components/Attachments/constants'
import { ErrorCode, FileError } from 'react-dropzone'

export const fileOnDropRejectedMessage = (error: FileError) => {
  if (error.code === ErrorCode.FileTooLarge) {
    return fileuploadErrors.FILE_SIZE
  }
  if (error.code === ErrorCode.FileInvalidType) {
    return fileuploadErrors.FILE_TYPE
  }
  return error?.message
}
